import { PublicHeader, PublicFooter, usePublicLocale } from "../components/PublicLayout"
import { privacyPolicy, PRIVACY_UPDATED_AT } from "../content/privacyPolicy"

const PrivacyPolicyPage = () => {
  const { language } = usePublicLocale()
  const policy = privacyPolicy[language]
  const updated = new Intl.DateTimeFormat(language, {
    year: "numeric", month: "long", day: "numeric", timeZone: "UTC",
  }).format(new Date(`${PRIVACY_UPDATED_AT}T00:00:00Z`))

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-50">
      <PublicHeader />
      <main className="public-document">
        <article>
          <div className="public-document-lead">
            <h1>{policy.title}</h1>
            <p>{policy.updatedLabel}: <time dateTime={PRIVACY_UPDATED_AT}>{updated}</time></p>
            <p>{policy.description}</p>
          </div>
          <nav className="public-card public-toc" aria-label={policy.contentsLabel}>
            <h2>{policy.contentsLabel}</h2>
            <ol>
              {policy.sections.map(({ id, title }) => (
                <li key={id}><a href={`#${id}`}>{title}</a></li>
              ))}
            </ol>
          </nav>
          {policy.sections.map(({ id, title, paragraphs, items, links }) => (
            <section className="public-card" id={id} key={id} aria-labelledby={`${id}-title`}>
              <h2 id={`${id}-title`}>{title}</h2>
              {paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
              {items && <ul>{items.map((item) => <li key={item}>{item}</li>)}</ul>}
              {links && <ul>{links.map(({ label, href }) => <li key={href}><a href={href}>{label}</a></li>)}</ul>}
            </section>
          ))}
        </article>
      </main>
      <PublicFooter />
    </div>
  )
}

export default PrivacyPolicyPage
